module.exports = __webpack_public_path__ + "img/Books.ef1f9b02.svg";